var map = {
	"./en/algorithm-strm.png": [
		17740,
		7740
	],
	"./es/algorithm-strm.png": [
		34985,
		4985
	],
	"./pt/algorithm-strm.png": [
		66702,
		6702
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99257;
module.exports = webpackAsyncContext;